import $ from 'jquery';
import Swal from 'sweetalert2'
import * as requestLib from '../lib/requestLib'

let baseUrl = requestLib.getUrl();

export default {

    requestStepSearch: (url, data, callback, errorCallback = () => { }) => {
        $.ajax({
            url: url,
            data: JSON.stringify(data),
            method: "post",
            contentType: "application/json",
            dataType: "json",
            timeout: 180000,
            success: function (res) {
                callback(res)
            },
            error: (req, status, err) => {
                errorCallback(req, status, err);
            }
        })
    },

    requestPost: (url, data, callback, errorCallback = () => { }) => {
        url = baseUrl + url;
        $.ajax({
            url,
            data,
            dataType: 'json',
            type: 'post',
            timeout: 180000,
            beforeSend: function (xhr) {
            },
            success: function (res) {
                // console.log(res);
                callback(res)
            },
            error: (req, status, err) => {
                errorCallback(req, status, err);
            }
        })
    },

    requestGet: (url, data, callback, errorCallback = () => { }) => {
        url = baseUrl + url;
        $.ajax({
            url,
            data,
            beforeSend: function (xhr) {
            },
            dataType: 'json',
            type: 'get',
            timeout: 180000,
            success: res => {
                callback(res)
            },
            error: (req, status, err) => {
                errorCallback(req, status, err);
                // console.log(req, status, err)
            }
        })
    },

    getCookie: (name) => {
        let value = "; " + document.cookie;
        let parts = value.split("; " + name + "=");
        if (parts.length === 2) return parts.pop().split(";").shift();
    },

    makeParameter: (userId, accessToken, code, searchList) => {
        let keyword = "";
        let prevList = [];

        //console.log(searchList);

        for (let i = 0; i < searchList.length; i++) {
            let keywordList = [];

            if (searchList[i].code === 4) {
                if (searchList[i].keyword) {
                    searchList[i].keyword.map(keywordItem => {
                        if (code !== 5) keywordList.push(keywordItem.title);
                        keywordList = keywordList.concat(keywordItem.keyword);
                    })
                }
            } else {
                if (searchList[i].keyword) {
                    searchList[i].keyword.map(item => {
                        let value;

                        if (item.name)
                            value = item.name;
                        else if (item.title)
                            value = item.title;
                        else
                            value = item;

                        keywordList.push(value);
                    })
                }
            }

            if (searchList[i].condition === "editable") {

                // 직전 스텝 data get
                keyword = keywordList.join(",");

            } else if (searchList[i].condition === "complete") {
                prevList.push({ step_code: searchList[i].code, data: keywordList.join(",") });
            }
        }

        let data = {
            session_id: userId,
            uniq_id: accessToken,
            data_set: {
                target_step_code: code,
                data_input: {
                    step_code: code,
                    data: keyword
                },
                data_prev: prevList
            }
        };

        return data;
    },

    makeId(length) {
        let text = "";
        let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (let i = 0; i < length; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));

        return text;
    }
}